var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { Skeleton } from '@mui/material';
import { Wrapper } from 'app/components/styles/districtModules/headerStyles';
import { SIZES, Typography } from '@fupa/fupa-uikit';
import React from 'react';
import styled from 'styled-components';
import { Heading } from 'app/components/competitionModule/header/headerStyles';
const IconContainer = styled.div.withConfig({
  componentId: "sc-9q3sr6-0"
})(["height:", ";width:", ";margin-right:", ";border-radius:50%;", ""], SIZES['36'], SIZES['36'], SIZES['8'], props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      height: ", ";\n      width: ", ";\n      margin-right: ", ";\n    "])), SIZES['48'], SIZES['48'], SIZES['16']));
const Icon = styled.div.withConfig({
  componentId: "sc-9q3sr6-1"
})(["height:", ";width:", ";", ""], SIZES['36'], SIZES['36'], props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      height: ", ";\n      width: ", ";\n    "])), SIZES['48'], SIZES['48']));
export default function HeaderSkeleton(_ref) {
  let {
    animation
  } = _ref;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "HeaderSkeleton",
    "data-sentry-source-file": "HeaderSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(IconContainer, {
    "data-sentry-element": "IconContainer",
    "data-sentry-source-file": "HeaderSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "circular",
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "HeaderSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Icon, {
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "HeaderSkeleton.tsx"
  }))), /*#__PURE__*/React.createElement(Heading, {
    as: "div",
    "data-sentry-element": "Heading",
    "data-sentry-source-file": "HeaderSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: animation,
    "data-sentry-element": "Skeleton",
    "data-sentry-source-file": "HeaderSkeleton.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "headline2",
    component: "span",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "HeaderSkeleton.tsx"
  }, "Regionalliga Bayern"))));
}